/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AccountSummary } from '../models';
// @ts-ignore
import type { Trading212ApiCredentialUpdateRequest } from '../models';
// @ts-ignore
import type { Trading212CredentialUpdateRequest } from '../models';
/**
 * Trading212CredentialsApi - axios parameter creator
 * @export
 */
export const Trading212CredentialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Health check Trading212 public API credentials
         * @param {ApiHealthCheckAccountIdEnum} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthCheck: async (accountId?: ApiHealthCheckAccountIdEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/trading212-credentials/api/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate Trading212 credential by testing API connectivity
         * @summary Health check Trading212 credential
         * @param {HealthCheckPathCredentialKeyEnum} credentialKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckPath: async (credentialKey: HealthCheckPathCredentialKeyEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialKey' is not null or undefined
            assertParamExists('healthCheckPath', 'credentialKey', credentialKey)
            const localVarPath = `/api/trading212-credentials/health-check/{credentialKey}`
                .replace(`{${"credentialKey"}}`, encodeURIComponent(String(credentialKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Trading212 public API credential (key or secret)
         * @param {Trading212ApiCredentialUpdateRequest} trading212ApiCredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiCredential: async (trading212ApiCredentialUpdateRequest: Trading212ApiCredentialUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trading212ApiCredentialUpdateRequest' is not null or undefined
            assertParamExists('updateApiCredential', 'trading212ApiCredentialUpdateRequest', trading212ApiCredentialUpdateRequest)
            const localVarPath = `/api/trading212-credentials/api/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trading212ApiCredentialUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Trading212 authentication credentials
         * @summary Update Trading212 credential
         * @param {Trading212CredentialUpdateRequest} trading212CredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredential: async (trading212CredentialUpdateRequest: Trading212CredentialUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trading212CredentialUpdateRequest' is not null or undefined
            assertParamExists('updateCredential', 'trading212CredentialUpdateRequest', trading212CredentialUpdateRequest)
            const localVarPath = `/api/trading212-credentials/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trading212CredentialUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Trading212CredentialsApi - functional programming interface
 * @export
 */
export const Trading212CredentialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Trading212CredentialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Health check Trading212 public API credentials
         * @param {ApiHealthCheckAccountIdEnum} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHealthCheck(accountId?: ApiHealthCheckAccountIdEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHealthCheck(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CredentialsApi.apiHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate Trading212 credential by testing API connectivity
         * @summary Health check Trading212 credential
         * @param {HealthCheckPathCredentialKeyEnum} credentialKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheckPath(credentialKey: HealthCheckPathCredentialKeyEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheckPath(credentialKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CredentialsApi.healthCheckPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Trading212 public API credential (key or secret)
         * @param {Trading212ApiCredentialUpdateRequest} trading212ApiCredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiCredential(trading212ApiCredentialUpdateRequest: Trading212ApiCredentialUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiCredential(trading212ApiCredentialUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CredentialsApi.updateApiCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Trading212 authentication credentials
         * @summary Update Trading212 credential
         * @param {Trading212CredentialUpdateRequest} trading212CredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCredential(trading212CredentialUpdateRequest: Trading212CredentialUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCredential(trading212CredentialUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Trading212CredentialsApi.updateCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Trading212CredentialsApi - factory interface
 * @export
 */
export const Trading212CredentialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Trading212CredentialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Health check Trading212 public API credentials
         * @param {ApiHealthCheckAccountIdEnum} [accountId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHealthCheck(accountId?: ApiHealthCheckAccountIdEnum, options?: RawAxiosRequestConfig): AxiosPromise<AccountSummary> {
            return localVarFp.apiHealthCheck(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate Trading212 credential by testing API connectivity
         * @summary Health check Trading212 credential
         * @param {HealthCheckPathCredentialKeyEnum} credentialKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckPath(credentialKey: HealthCheckPathCredentialKeyEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.healthCheckPath(credentialKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Trading212 public API credential (key or secret)
         * @param {Trading212ApiCredentialUpdateRequest} trading212ApiCredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiCredential(trading212ApiCredentialUpdateRequest: Trading212ApiCredentialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateApiCredential(trading212ApiCredentialUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Trading212 authentication credentials
         * @summary Update Trading212 credential
         * @param {Trading212CredentialUpdateRequest} trading212CredentialUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCredential(trading212CredentialUpdateRequest: Trading212CredentialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateCredential(trading212CredentialUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Trading212CredentialsApi - object-oriented interface
 * @export
 * @class Trading212CredentialsApi
 * @extends {BaseAPI}
 */
export class Trading212CredentialsApi extends BaseAPI {
    /**
     * 
     * @summary Health check Trading212 public API credentials
     * @param {ApiHealthCheckAccountIdEnum} [accountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CredentialsApi
     */
    public apiHealthCheck(accountId?: ApiHealthCheckAccountIdEnum, options?: RawAxiosRequestConfig) {
        return Trading212CredentialsApiFp(this.configuration).apiHealthCheck(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate Trading212 credential by testing API connectivity
     * @summary Health check Trading212 credential
     * @param {HealthCheckPathCredentialKeyEnum} credentialKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CredentialsApi
     */
    public healthCheckPath(credentialKey: HealthCheckPathCredentialKeyEnum, options?: RawAxiosRequestConfig) {
        return Trading212CredentialsApiFp(this.configuration).healthCheckPath(credentialKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Trading212 public API credential (key or secret)
     * @param {Trading212ApiCredentialUpdateRequest} trading212ApiCredentialUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CredentialsApi
     */
    public updateApiCredential(trading212ApiCredentialUpdateRequest: Trading212ApiCredentialUpdateRequest, options?: RawAxiosRequestConfig) {
        return Trading212CredentialsApiFp(this.configuration).updateApiCredential(trading212ApiCredentialUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Trading212 authentication credentials
     * @summary Update Trading212 credential
     * @param {Trading212CredentialUpdateRequest} trading212CredentialUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof Trading212CredentialsApi
     */
    public updateCredential(trading212CredentialUpdateRequest: Trading212CredentialUpdateRequest, options?: RawAxiosRequestConfig) {
        return Trading212CredentialsApiFp(this.configuration).updateCredential(trading212CredentialUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiHealthCheckAccountIdEnum = {
    Primary: 'primary',
    Ina: 'ina'
} as const;
export type ApiHealthCheckAccountIdEnum = typeof ApiHealthCheckAccountIdEnum[keyof typeof ApiHealthCheckAccountIdEnum];
/**
 * @export
 */
export const HealthCheckPathCredentialKeyEnum = {
    Trading212Isa: 'Trading212Isa',
    Trading212Cfd: 'Trading212Cfd',
    Trading212ApiKey: 'Trading212ApiKey'
} as const;
export type HealthCheckPathCredentialKeyEnum = typeof HealthCheckPathCredentialKeyEnum[keyof typeof HealthCheckPathCredentialKeyEnum];
